export default {
  admin: {
    invoice: {
      title: "Abrechnung — Buchhaltungscodierung",
      tab: {
        payers: "Drittzahler",
        sequence: "Belegnummernkreis",
        article_codes: "Artikelcodes",
        terms_of_payment: "Zahlungsbedingungen",
        bank_details: "Bankverbindung",
      },
      alert: {
        locked: "Einstellung durch den Plattformadministrator gesperrt",
        payer:
          "Diese Werte werden von jedem Unternehmen bei seiner Erstellung übernommen. Sie bleiben individuell auf der Unternehmensseite bearbeitbar.",
        article_code:
          "Der Code ist gesperrt und kann nicht geändert werden. Alle anderen Felder sind anpassbar — klicken Sie auf den Stift, um eine Zeile zu bearbeiten.",
        payment_code:
          "Diese Referenztabellen speisen die an Sage übermittelten Buchungssätze. Vom STUDEA-Team definierte Codes — nicht änderbar.",
        bank_details:
          "Vertrauliche Informationen — an die Convergence-API übermittelt und auf den Buchhaltungsbelegen angezeigt.",
        sequence_info:
          "Mehrere Finanzierertypen können nicht denselben Nummernkreis verwenden. Aktivieren Sie die betreffenden Typen in jedem Block.",
      },
      sequence: {
        add: "Einen Nummernkreis hinzufügen",
        add_success: "Nummernkreis erfolgreich hinzugefügt!",
        add__confirm: "Sind Sie sicher, dass Sie einen Nummernkreis hinzufügen möchten?",
        update_success: "Daten erfolgreich aktualisiert!",
        stats: {
          invoices: "Ausgestellte Rechnungen",
          credits: "Ausgestellte Gutschriften",
          anomalies: "Nummernkreis-Anomalien",
        },
      },
      payers: {
        actions: {
          apply_collective_account: {
            title: "Sammelkonto anwenden",
            subtitle: "Auf private Unternehmen ohne definiertes Konto",
            subtitle_public: "Auf öffentliche Unternehmen ohne definiertes Konto",
          },
          payment_terms: {
            title: "Zahlungsbedingungen anwenden",
            subtitle: "Auf private Unternehmen ohne definierte Bedingungen",
            subtitle_public: "Auf öffentliche Unternehmen ohne definierte Bedingungen",
          },
          missing_subsidiary_ledgers: {
            title: "Fehlende Nebenkonten generieren",
            subtitle: "Bestehende Nummern werden nicht überschrieben",
          },
        },
        update: {
          success: "Daten erfolgreich aktualisiert!",
        },
        apply: {
          success: "{count} Unternehmen aktualisiert",
          opco: {
            success: "{count} OPCO(s) aktualisiert",
          },
        },
      },
      article_code: {
        edit: {
          success: "Artikelcode erfolgreich geändert!",
        },
      },
      action: {
        deactivate: "Deaktivieren",
        activate: "Aktivieren",
      },
      payment_code: {
        activated: {
          success: ({ plural }) => plural(["Code erfolgreich deaktiviert!", "Code erfolgreich aktiviert!"]),
        },
        toggle_error: "Fehler beim Aktualisieren der angezeigten Daten, bitte laden Sie die Seite neu",
      },
      bank_details: {
        success: "Bankverbindung erfolgreich geändert!",
      },
    },
    help_settings: "Hilfe-Einstellungen",
    help_settings_success: "Hilfe-Einstellungen erfolgreich geändert!",
    lastEmail: "Link der letzten gesendeten E-Mail",
    generatePassword: "Passwort neu generieren und senden",
    switchUser: "{name} verkörpern",
    switchAdmin: "Sie verkörpern",
    switchAdminLabel: "Admin",
    switchPilot: "Pilot",
    modify: "{title} bearbeiten",
    show: "{title} anzeigen",
    delete: "{title} löschen",
    add: "Hinzufügen",
    name: "Name",
    title: "Titel",
    year: "Jahr",
    trainingOpeningStart: "Beginn der Ausbildungsöffnungen",
    trainingOpeningEnd: "Ende der Ausbildungsöffnungen",
    level: "Niveau",
    registrationDate: "Registrierungsdatum",
    active: "Aktiv",
    activateOption: "Aktivieren/Deaktivieren",
    management_of: "Verwaltung von",
    contents: "Inhalte",
    users: "Benutzer",
    trainings: "Ausbildungen",
    archiving: {
      title: "Archivierung",
      action: "Archivieren",
      archive_confirmation: "Möchten Sie diese Gruppen wirklich archivieren?",
      active_confirmation: "Möchten Sie diese Gruppen wirklich dearchivieren?",
      archive_success: "Gruppen erfolgreich archiviert!",
      active_success: "Gruppen erfolgreich dearchiviert!",
    },
    current_training_course_year: {
      title: "Aktuelles Jahr ändern",
      error: "Das Referenzjahr muss sich vom neuen aktuellen Jahr unterscheiden",
      confirmation: {
        title: "Möchten Sie das aktuelle Jahr wirklich ändern?",
        subtitle: "Es wird bei allen Gruppen geändert, die das Referenzjahr als Startjahr haben",
      },
      success: ({ named }) => `Aktuelles Jahr auf ${named("count")} Gruppen geändert`,
    },
    livretConfig: {
      title: "Aktivierung des Hefts",
      confirmation: "Möchten Sie diese Daten wirklich ändern?",
      success: "Heftkonfiguration erfolgreich gespeichert!",
    },
    modules: "Module",
    module: "Modul",
    code: "Code",
    error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut!",
    lastName: "Nachname",
    firstName: "Vorname",
    profile: "Profil",
    embody: "Verkörpern",
    visible: "Sichtbar",
    popup: "Popup",
    visibleHomeLea: "Sichtbar",
    endDate: "Enddatum",
    startDate: "Startdatum",
    contractTypeColor: "Vertragsfarbe",
    none_duplicated_user: "Kein Benutzer zum Zusammenführen",
    skill: {
      title: ({ plural }) => plural(["Kompetenz", "Kompetenzen"]),
    },
    skillCategory: {
      title: "Kategorie",
    },
    skill_session: {
      generate: "Zeiträume generieren",
      empty:
        "Sie müssen in der Modulkonfiguration eine Anzahl zu erstellender Zeiträume angeben, bevor Sie diese konfigurieren können",
      generation_success: "Zeiträume erfolgreich generiert",
      existing_session: "Sie sind dabei, bestehende Zeiträume zu löschen. Sind Sie sicher?",
    },
    skillReferential: {
      title: "Kompetenzreferential",
      edit: "Referential bearbeiten",
    },
    skill_import_france_competence: {
      title: "Alle France Compétences-Referentiale importieren",
      confirm: "Möchten Sie wirklich alle France Compétences-Referentiale laden?",
      success: "Referentiale erfolgreich importiert!",
    },
    navigation: {
      users: "Benutzer",
      trainings: "Ausbildungen",
      modules: "Module",
      settings: "Konfiguration",
      general: "Allgemein",
      steering: "Steuerung",
    },
    home: {
      title: "Allgemeine Konfiguration",
      title2: "Übersicht",
      title3: "Automatische Synchronisation",
      title4: "Allgemeine Statistiken",
      active: "Aktiviert",
      unique_connection: "Einmalige Verbindung",
      apprentices_mentor: "Auszubildende und Mentoren",
    },
    log: {
      title: ({ plural }) => plural(["Log", "Logs"]),
      view: "Geänderte Daten anzeigen",
      modify_field: "Geändertes Feld",
      old_data: "Alte Daten",
      data: "Neue Daten",
      impersonation_chain: "Vertretungskette",
      impersonator_type: {
        zama: "Zama-Administrator",
        studea: "Studea-Administrator",
        studea_admin: "Studea-Administrator",
        studea_manager: "Studea-Verantwortlicher",
      },
    },
    ypareoReporting: {
      title: ({ plural }) => plural(["Ypareo-Bericht", "Ypareo-Berichte"]),
      view: "Bericht anzeigen",
    },
    edusignReporting: {
      title: ({ plural }) => plural(["Edusign-Bericht", "Edusign-Berichte"]),
      view: "Bericht anzeigen",
    },
    registrationAlert: {
      title: ({ plural }) => plural(["Warnung", "Warnungen"]),
    },
    ammonReporting: {
      title: ({ plural }) => plural(["Ammon-Bericht", "Ammon-Berichte"]),
      view: "Bericht anzeigen",
    },
    ggeReporting: {
      title: ({ plural }) => plural(["GGE-Bericht", "GGE-Berichte"]),
      view: "Bericht anzeigen",
    },
    ssoReporting: {
      title: ({ plural }) => plural(["SSO-Bericht", "SSO-Berichte"]),
      view: "Bericht anzeigen",
    },
    ofalinkReporting: {
      name: "Ofa-Link",
      title: ({ plural }) => plural(["Ofa-Link-Bericht", "Ofa-Link-Berichte"]),
      view: "Bericht anzeigen",
    },
    report: {
      title: ({ plural }) => plural(["Bericht", "Berichte"]),
      view: "Bericht anzeigen",
    },
    mail: {
      title: ({ plural }) => plural(["E-Mail", "E-Mails"]),
      view: "E-Mail-Inhalt anzeigen",
      recipient: "Empfänger:",
      status: "Sendestatus:",
      sent_on: "Gesendet am:",
      open_on: "Geöffnet am:",
      error_message: "Fehlermeldung",
      no_error_message: "Der Server hat keine Meldung zurückgegeben.",
    },
    registrationField: {
      title: ({ plural }) => plural(["Feld", "Felder"]),
    },
    registrationBlock: {
      title: ({ plural }) => plural(["Block", "Blöcke"]),
    },
    registrationTab: {
      title: ({ plural }) => plural(["Reiter", "Reiter"]),
    },
    registrationStep: {
      title: ({ plural }) => plural(["Schritt", "Schritte"]),
    },
    registrationDataVersion: {
      title: ({ plural }) => plural(["Version", "Versionen"]),
      notEmpty: "Formulare sind bereits dieser Version zugeordnet",
    },
    registrationDevice: {
      title: ({ plural }) => plural(["Gerät", "Geräte"]),
    },
    registrationDataConfiguration: "Versionskonfiguration bearbeiten",
    cerfaParam: {
      title: ({ plural }) => plural(["CERFA-Konfiguration", "CERFA-Konfigurationen"]),
    },
    role: {
      title: ({ plural }) => plural(["Rolle", "Rollen"]),
    },
    triad: {
      title: ({ plural }) => plural(["Trinôme", "Trinômes"]),
      delete_all_triad: {
        title: "Alle Trinômes löschen",
        confirmation: "Möchten Sie alle Trinômes dieser Gruppe wirklich löschen?",
        success: "Trinômes erfolgreich gelöscht!",
      },
    },
    studeaUser: {
      title: ({ plural }) => plural(["Benutzer", "Benutzer"]),
    },
    user: {
      title: ({ plural }) => plural(["Benutzer", "Benutzer"]),
      actions: {
        keep_user: "Behalten",
        delete_user: "Löschen",
        unselect_user: "Diesen Benutzer abwählen",
        reset_password: {
          success: "Der Link zum Zurücksetzen des Passworts wurde erfolgreich an den Benutzer gesendet!",
        },
      },
      add_profile: "Profil hinzufügen",
      warning_profile: "Profil löschen",
      warning_profile_text: "Möchten Sie dieses Profil wirklich löschen?",
      last_connection: "Letzte Verbindung am: \n",
      search_user_by_name_or_mail: "Benutzer nach Name oder E-Mail suchen",
      import_users: "Benutzer importieren",
      profile_config: "Profilkonfiguration",
      merge: "Benutzer zusammenführen",
      duplicated_user_count: "doppelte Benutzer zum Zusammenführen",
      merge_duplicated_user_confirmation: "Möchten Sie diese Benutzer wirklich zusammenführen?",
      merge_success: "Zusammenführung erfolgreich durchgeführt",
      no_double_user: "Keine Duplikate gefunden",
      mail_address: "E-Mail-Adresse",
      already_connected: "Hat sich bereits im Heft angemeldet",
      yes: "Ja",
      no: "Nein",
      row: "Zeile",
      reference_user: "Referenzbenutzer",
      duplicated_user: "Duplikate",
      reset_choices: "Auswahl zurücksetzen",
      options: "Optionen",
      account_creation: "Kontoerstellung",
      username: "Kennung",
      external_id: "Externe ID",
      birth_date: "Geburtsdatum",
      send_credential_back_to_user: "Anmeldedaten erneut an den betreffenden Benutzer senden",
      reference_user_is_not_duplicate: "Der Referenzbenutzer ist kein Duplikat",
      keep: "Behalten",
      delete: "Löschen",
      export: "Exportieren",
      send: "Speichern",
      profile_title: "Bezeichnungen der Benutzerprofile",
      users_profile_title_list: "Liste der Benutzerprofilbezeichnungen",
      modify_profile: "Bezeichnung bearbeiten",
      modification_succes: "Profil erfolgreich bearbeitet",
      no_mail_title: "Kein Link",
      no_mail: "Dieser Benutzer hat noch keinen Link zum Zurücksetzen seines Passworts erhalten!",
      profile_user_info:
        "Erstellen Sie verschiedene Pilotprofile mit spezifischen Rechten, die danach den Benutzern zugewiesen werden können. Beispiel: Anwesenheitsverwalter, pädagogisch Verantwortlicher, ….",
      role: {
        NONE: "Nein",
        ALL: "Ja",
        VIEW: "Anzeigen",
        EDIT: "Bearbeiten",
        DELETE: "Löschen",
      },
      erase_studeaManager_profile:
        "Achtung: Sie sind dabei, das/die Ihrem Konto zugeordnete(n) Pilotprofil(e) zu löschen",
    },
    profile_label: {
      titleAbbreviation: "Abkürzung",
      titlePlural: "Titel im Plural",
      titleWithArticle: "Titel mit Artikel",
    },
    training: {
      title: ({ plural }) => plural(["Ausbildung", "Ausbildungen"]),
      ufa_add_test: "Test-Ausbildung erstellen",
      genere_triad_test: "Test-Trinômes generieren",
      generate_triad_test_confirmation: "Möchten Sie wirklich Test-Trinômes für alle Ausbildungen erstellen?",
      genere_triad_test_success: "Test-Trinômes erfolgreich erstellt!",
      genere_training_test_success: "Test-Ausbildung erfolgreich erstellt!",
      import_triad: "Trinômes importieren",
      confirmation_subtitle: "Diese Löschung führt auch zur Löschung der mit dieser Ausbildung verknüpften Gruppen",
    },
    modele: {
      title: ({ plural }) => plural(["Vorlage", "Vorlagen"]),
    },
    variable: {
      title: ({ plural }) => plural(["Variable", "Variablen"]),
    },
    registration: {
      title: ({ plural }) => plural(["Anmeldung", "Anmeldungen"]),
    },
    trainingCourse: {
      title: ({ plural }) => plural(["Gruppe", "Gruppen"]),
      duplicate_on_next_year: "Gruppe auf das nächste Jahr duplizieren",
      duplicate: "Gruppe duplizieren",
      delete: "Gruppe löschen",
    },
    copy: {
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich kopiert!`, `${named("name")} erfolgreich kopiert!`]),
      title: ({ plural, named }) =>
        plural([`Dieses/n ${named("name")} kopieren`, `Dieses/n ${named("name")} kopieren`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Möchten Sie dieses/n ${named("name")} wirklich kopieren?`,
          `Möchten Sie dieses/n ${named("name")} wirklich kopieren?`,
        ]),
      error: ({ plural, named }) =>
        plural([
          `Beim Kopieren von ${named("name")} ist ein Fehler aufgetreten.`,
          `Beim Kopieren von ${named("name")} ist ein Fehler aufgetreten.`,
        ]),
    },
    studeaManager: {
      title: ({ plural }) => plural(["Pilot", "Piloten"]),
    },
    design: {
      title: "Gestaltung",
    },
    dataAgreement: {
      title: ({ plural }) => plural(["Datenschutzrichtlinie", "Datenschutzrichtlinien"]),
    },
    institution: {
      title: ({ plural }) => plural(["Einrichtung", "Einrichtungen"]),
      list: {
        title: "Die aktiven Einrichtungen",
      },
      export: {
        booklets: "Export der Hefte der Einrichtung",
        answers: "Antworten auf Fragebögen des Vorjahres",
      },
    },
    document: {
      title: ({ plural }) => plural(["Öffentliches Dokument", "Öffentliche Dokumente"]),
    },
    documentCategory: {
      title: ({ plural }) => plural(["Dokumentenkategorie", "Dokumentenkategorien"]),
    },
    helpDocument: {
      title: ({ plural }) => plural(["Online-Hilfe", "Online-Hilfen"]),
    },
    component: {
      title: ({ plural }) => plural(["Komponente", "Komponenten"]),
      export: {
        title: "Antworten auf Fragebögen des Vorjahres",
      },
    },
    degree: {
      title: ({ plural }) => plural(["Abschlussart", "Abschlussarten"]),
    },
    contractType: {
      title: ({ plural }) => plural(["Vertragsart", "Vertragsarten"]),
    },
    planContract: {
      title: ({ plural }) => plural(["Ausbildungsjahr", "Ausbildungsjahre"]),
      actions: {
        activate: {
          title: "Aktivieren",
          success: "Ausbildungsjahr erfolgreich aktiviert!",
        },
        activate_recruitment: {
          title: "Für die Rekrutierung aktivieren",
          success: "Für die Rekrutierung erfolgreich aktiviert!",
        },
      },
    },
    titleRncp: {
      title: ({ plural }) => plural(["RNCP-Titel", "RNCP-Titel"]),
    },
    modulet: {
      title: ({ plural }) => plural(["Modul", "Module"]),
      list: {
        title: "Modulverwaltung",
      },
      trainingCourse: {
        edit: {
          title: "Mit dem Modul verknüpfte Ausbildungen bearbeiten",
          success: "Mit dem Modul verknüpfte Ausbildungen erfolgreich geändert!",
        },
        displayActive: "Nur mit dem Modul verknüpfte Ausbildungen anzeigen",
      },
      config: {
        title: "Modulkonfiguration",
      },
      skill_session: {
        title: "Zeiträume generieren",
      },
      registration: {
        title: "Anmeldungs-Dashboard",
      },
      skill_referential: {
        title: "Kompetenzreferential",
        list: "Die Referentiale",
        edit: "Referential bearbeiten",
        config: "Modulkonfiguration",
      },
    },
    template: {
      title: ({ plural }) => plural(["Vorlage", "Vorlagen"]),
      success: "Vorlage erfolgreich geändert!",
      duplicate: "Diese Vorlage duplizieren",
      default_template: "Standardvorlage",
    },
    absenceReason: {
      title: ({ plural }) => plural(["Abwesenheitsgrund", "Abwesenheitsgründe"]),
    },
    questionnaireConfig: {
      title: "Fragebogenmodul-Konfiguration",
      multiple_actions: "Fragebögen bearbeiten",
      action_to_do: "Durchzuführende Aktionen",
      warning:
        "Diese Aktion führt zur Änderung aller Fragebögen des ausgewählten Jahres mit dem ausgewählten Titel. Leer gelassene Felder werden nicht geändert",
      confirmation: "Möchten Sie diese Daten wirklich ändern?",
      success: "Fragebögen erfolgreich geändert!",
    },
    ypareoConfig: {
      title: "Ypareo-Modulkonfiguration",
      get_directories: "Ypareo-Verzeichnisse abrufen",
      reference_tables: {
        tab_title: "Referenztabellen",
        intro:
          "Diese Tabellen werden einmal von Ypareo abgerufen und in Studea gespeichert, damit die Synchronisierung einer Akte Ypareo nicht mehr bei jeder Übertragung abfragen muss.",
        refresh_button: "Von Ypareo aktualisieren",
        refresh_success: "Tabelle erfolgreich aktualisiert",
        mapping_saved: "Zuordnung gespeichert",
        last_refreshed_at: "Letzte Aktualisierung: {date}",
        never_refreshed: "Noch nie aktualisiert",
        active_count: ({ plural, named }) =>
          plural([`${named("count")} aktive Zeile`, `${named("count")} aktive Zeilen`]),
        show_inactive: "Inaktive Zeilen anzeigen",
        code_column: "Ypareo-Code (nur lesbar)",
        label_column: "Ypareo-Bezeichnung (nur lesbar)",
        mapping_column: "Studea-Zuordnung",
        active_column: "Status",
        active_value: "Aktiv",
        inactive_value: "Inaktiv",
        no_studea_values:
          "Aktuell ist kein Studea-Wert für dieses Referenzverzeichnis verfügbar — die Zuordnung kann noch nicht erfasst werden.",
        read_only_notice:
          "Dieses Referenzverzeichnis kann eingesehen und aktualisiert werden, seine Studea-Zuordnung wird jedoch nicht zeilenweise erfasst: Sie erfolgt über eine Kombination (Status, Abschluss, Jahr, Wiederholer) auf einer eigenen Seite.",
        no_rows:
          "Keine Zeile für dieses Referenzverzeichnis. Starten Sie eine Aktualisierung, um es aus Ypareo zu befüllen.",
        mapping_aria_label: "Studea-Zuordnung für {label}",
        table_caption: "Referenztabelle {label}",
        types: {
          civility: "Anrede",
          nationality: "Staatsangehörigkeit",
          birth_country: "Geburtsland",
          school_origin: "Schulische Herkunft",
          obtained_degree: "Erworbener Abschluss",
          employer_type: "Arbeitgebertyp",
          situation: "Situation",
        },
      },
      exclusion_refresh: {
        intro:
          "Diese Listen werden einmal von Ypareo abgerufen und in Studea gespeichert, um die Ausschlussfilter des folgenden Tabs zu befüllen.",
        refresh_button: "Von Ypareo aktualisieren",
        refresh_success: "Liste erfolgreich aktualisiert",
        last_refreshed_at: "Letzte Aktualisierung: {date}",
        never_refreshed: "Noch nie aktualisiert",
        active_count: ({ plural, named }) =>
          plural([`${named("count")} aktive Zeile`, `${named("count")} aktive Zeilen`]),
        types: {
          status: "Status",
          group: "Gruppen",
        },
      },
      exclusion_list: {
        add_button: "Ausschluss hinzufügen",
        empty: "Kein Ausschluss gespeichert",
        code_column: "Code",
        label_column: "Bezeichnung",
        delete_button: "Löschen {code}",
        delete_confirm_title: "Diesen Ausschluss entfernen?",
        delete_confirm_subtitle: "Der Code {code} wird aus der Liste entfernt.",
        delete_success: "Ausschluss erfolgreich entfernt",
        modal_title: "Ausschluss hinzufügen — {label}",
        add_button_inclusion: "Einschluss hinzufügen",
        modal_title_inclusion: "Einschluss hinzufügen — {label}",
        empty_inclusion: "Kein Einschluss gespeichert",
        delete_confirm_title_inclusion: "Diesen Einschluss entfernen?",
        delete_confirm_subtitle_inclusion: "Der Code {code} wird aus der Liste entfernt.",
        delete_success_inclusion: "Einschluss erfolgreich entfernt",
        search_label: "Suche in {label}",
        search_placeholder: "Mindestens 3 Zeichen eingeben",
        searching: "Suche läuft...",
        no_result: "Kein Ergebnis",
        results_found: ({ plural, named }) =>
          plural([`${named("count")} Ergebnis gefunden`, `${named("count")} Ergebnisse gefunden`]),
        add_result: "{label} hinzufügen",
        add_success: "{label} erfolgreich hinzugefügt",
        included_group_title: "Eingeschlossene Gruppencodes",
        previous_group_title: "Gruppencodes, die trotz Zugehörigkeit zum vorherigen Zeitraum importiert werden",
        excluded_group_title: "Ausgeschlossene Gruppencodes",
        excluded_apprentice_title: "Ausgeschlossene Auszubildende",
        mode_help: "Der Moduswechsel wird erst beim nächsten Speichern übernommen.",
      },
    },
    driverLicenceConfig: {
      title: "Führerschein-B-Modulkonfiguration",
    },
    studeaManagerProfile: {
      title: ({ plural }) => plural(["Pilotprofil", "Pilotprofile"]),
      all_access: "Alle Berechtigungen aktivieren",
    },
    historic: {
      title: "Verlauf",
    },
    statistic: {
      title: "Statistiken",
      general: "Allgemein",
      questionnaires: "Fragebögen",
      absence: "Abwesenheiten",
      course: "Kursverfolgung",
      global_export: "Statistiken exportieren",
      updated_on: "aktualisiert am",
      indicators_generated: "Ergänzende Indikatoren werden generiert",
    },
    export: {
      title: "Die Exporte",
      year: "Die Gruppen",
      available_exports: "Verfügbare Exporte",
      signature_questionnaire_all: "Fragebogenunterschriften aller Abschlüsse exportieren",
      absence_cumulate_by_diploma: "Kumulierte Abwesenheiten nach Abschluss exportieren",
      absence_by_apprentice: "Abwesenheiten nach Auszubildenden exportieren",
      company_visits: "Unternehmensbesuche exportieren",
      contract: "Verträge exportieren",
      dashboard: "Verlaufsdashboard exportieren",
      summary_table: "Zusammenfassungstabelle exportieren",
      questionnaire: "Fragebogen exportieren",
      questionnaire_code_count: "Anzahl Fragebögen pro Code exportieren",
      category_questionnaires: "Fragebögen",
      category_absences: "Abwesenheiten",
      category_contracts: "Verträge",
      category_general: "Allgemein",
      category_reversibility: "Reversibilität",
      year_filter_hint: "Dieser Filter gilt nur für Exporte mit dem Kalendersymbol",
      year_filter_badge_tooltip: "Dieser Export berücksichtigt das oben ausgewählte Jahr",
      reversibility: "Portfolios, Kompetenzen und Abwesenheiten exportieren",
      reversibility_hint:
        "Einzelnes Archiv, gegliedert nach Einrichtung und dann nach Ausbildungsgruppe: Ausbildungsportfolios als PDF mit ihren Anhängen, Kompetenzbewertungen als PDF, Abwesenheiten als Excel-Datei. Ein Manifest weist den tatsächlich erzeugten Inhalt aus. Langwieriger Vorgang.",
      reversibility_confirm_title: "Export der Reversibilität starten?",
      reversibility_confirm_text:
        "Diese Aktion erzeugt ein mehrere Gigabyte großes Archiv und kann mehrere Stunden dauern. Nur beim endgültigen Austritt des Kunden starten.",
      reversibility_error: "Der Reversibilitätsexport ist fehlgeschlagen. Bitte versuchen Sie es später erneut.",
    },
    duplicate: {
      title: "Duplikationen",
    },
    archive: {
      title: "Archivierung",
    },
    news: {
      title: ({ plural }) => plural(["Neuigkeit", "Neuigkeiten"]),
      news_list: "Liste der Neuigkeiten",
      list: {
        title: "Neuigkeiten",
        uploaded_date: "Online gestellt am",
        see_more: "Mehr anzeigen",
        see_all_news: "Alle Neuigkeiten anzeigen",
        go_back_newslist: "Zurück zur Liste der Neuigkeiten",
      },
    },
    import: {
      modele: "Herunterzuladende Dateivorlage",
      triad_new_file:
        "Achtung: Eine neue Vorlage ist seit dem 18.09.2023 verfügbar.\n" +
        "          Bitte laden Sie diese herunter und verwenden Sie sie, um Ihre Trinômes hochzuladen.",
      triad_update:
        "Achtung: Es werden nur fehlende Mitglieder eines Trinômes aktualisiert. Keine Daten (Nachname, Vorname oder E-Mail) eines bestehenden Benutzers werden aktualisiert.",
      thanks: "Bitte ändern und/oder löschen Sie die Spalten der Vorlage nicht",
      contract_type_id: "Vertragsart-IDs (Spalte AM)",
    },
    text: "Text",
    dateToDisplay: "Anzuzeigendes Datum",
    emailContent: "E-Mail-Inhalt",
    picture: "Bild",
    subTitle: "Untertitel",
    tag: "Tag",
    video: "Video",
    activate_notification: "Benachrichtigungen aktivieren",
    activate_notification_success: "Benachrichtigungseinstellung aktualisiert",
    tutorial: {
      title: ({ plural }) => plural(["Studea-Tutorial", "Studea-Tutorials"]),
      admin: "Admin",
      studea_manager: "Pilot",
      user: "Benutzer",
    },
    ammonConfig: {
      title: "Ammon-Modulkonfiguration",
      synchronisation: "Synchronisation",
      confirmation: "Möchten Sie die Synchronisation mit Ammon wirklich starten?",
    },
    contractRuptureConfig: {
      title: "Erklärung von Vertragsauflösungen durch den Auszubildenden oder das Unternehmen",
    },
    reporting: {
      list: ({ named }) => `Die ${named("name")}-Berichte`,
    },
    cfa_config: {
      success: "CFA-Konfiguration erfolgreich geändert!",
    },
    last_report: "Letzter Bericht",
    opco: {
      success_update: "OPCO erfolgreich aktualisiert!",
      synchronisation_confirmation: "Möchten Sie diesen OPCO wirklich synchronisieren?",
      synchronisation_confirmation_subtitle:
        "Sie sind dabei, die Synchronisierung des OPCO {opco} manuell zu starten.<br /><br />Eine automatische Synchronisierung läuft bereits jede Nacht zwischen 00:00 und 03:00 Uhr.<br /><br />️ Bei wiederholten Aufrufen außerhalb dieses Zeitfensters kann der OPCO den Zugriff auf seine API sperren.<br /><br />Bestätigen Sie den Start der Synchronisierung?",
      success_synchronisation: "Synchronisierung gestartet!",
      api_key: {
        valid: "Gültiger CFaDock-API-Schlüssel",
        invalid: "Ungültiger CFaDock-API-Schlüssel",
      },
      error_synchronisation: "CFaDock API-Schlüssel ungültig",
      invoice: {
        details: "Abrechnungsdetails anzeigen",
        modal: {
          title: "Abrechnungsdetails von {opco}",
        },
        success_update: "Rechnungsadresse erfolgreich aktualisiert!",
      },
      files: {
        title: "OPCO-Akten (3 Jahre)",
        subtitle: "Alle OPCO zusammen",
      },
      sync_files: {
        title: "Synchronisierte Akten",
        subtitle: "Übereinstimmungsrate",
      },
      guide: {
        title: "Leseleitfaden",
        baseline: "Die Synchronisationsindikatoren verstehen",
        sync_file: {
          title: "Synchronisierte Akte",
          description:
            "Studea hat diese Akte mit ihrem OPCO-Äquivalent verknüpft. Die Daten (Status, DECA, Kostenübernahme) sind aktuell.",
        },
        corresponding: {
          title: "Wahrscheinliche Übereinstimmung",
          description:
            "Score 4/5: Ein Kriterium stimmt nicht überein. Die Akte wird nicht automatisch verknüpft; eine manuelle Bestätigung ist erforderlich.",
        },
        progression: {
          title: "Fortschrittsbalken",
          description:
            "Synchronisierte Akten / OPCO-Akten insgesamt. Orange, wenn eine oder mehrere Akten auf Bestätigung warten.",
        },
        sync_report: {
          title: "Synchronisationsbericht",
          description: "XLSX-Export: Details der Übereinstimmungskriterien (SIRET, RNCP, Daten, Namen) für jede Akte.",
        },
        manual_sync: {
          title: "Manuelle Synchronisation",
          description:
            "Für Tests und Ausnahmefälle vorbehalten. Die automatische Synchronisation läuft jede Nacht zwischen 00:00 und 03:00 Uhr.",
        },
        inactive: {
          title: "Inaktiver OPCO",
          description:
            "Verbindung nicht konfiguriert. Wenden Sie sich an Ihren Studea-Ansprechpartner, um sie zu aktivieren.",
        },
        matching_criteria: {
          title: "Übereinstimmungskriterien (Score /5)",
          description:
            "Geburtsdatum des Auszubildenden · Name des Auszubildenden · SIRET des Unternehmens · Vertragsbeginn · RNCP-Code.<br><strong>5/5</strong> → automatische Synchronisation  {'|'}  <strong>4/5</strong> → wahrscheinliche Übereinstimmung (manuelle Bestätigung)  {'|'}  <strong>< 4/5</strong> → keine Übereinstimmung.",
        },
      },
    },
    ia_competences: {
      config_confirmation:
        "Möchten Sie diese IA-Kompetenzen-Konfiguration wirklich auf die ausgewählten Gruppen anwenden?",
      config_success: "IA-Kompetenzen-Konfiguration erfolgreich angewendet!",
      reload_error: "Beim Neuladen der Daten ist ein Fehler aufgetreten.",
      tab_formations: "Ausbildungen",
      tab_promotions: "Gruppen",
      help_text:
        "Wählen Sie links die Ausbildungen oder Gruppen aus, legen Sie die anzuwendenden KI-Einstellungen fest und klicken Sie auf Anwenden.",
      apply: "Anwenden",
      apply_sticky_aria: "KI-Einstellungen auf die Auswahl anwenden",
      apply_footer_aria: "KI-Einstellungen auf die Auswahl anwenden",
      features_title: "KI-Funktionen",
      module1_title: "RNCP-Referential",
      module1_label: "Modul 1",
      module2_title: "Missionen & Aktivitäten",
      module2_label: "Modul 2",
      features_upcoming_title: "Kommende Funktionen",
      feature_enrichment: "Anreicherung",
      feature_enrichment_desc: "Schlägt ergänzende Kompetenzen auf Basis des importierten RNCP-Titels vor.",
      feature_program_breakdown: "Programmgliederung",
      feature_program_breakdown_desc: "Zerlegt ein Programm in Semester, Einheiten und Module.",
      feature_matrix: "UE/Kompetenzen-Matrix",
      feature_matrix_desc: "Generiert die Entsprechungsmatrix UE/Kompetenzen des Referentials.",
      feature_mission_breakdown: "Missionsgliederung",
      feature_mission_breakdown_desc:
        "Transformiert eine Mission in strukturierte Aktivitäten, die am Referential ausgerichtet sind.",
      feature_writing: "Schreibassistent",
      feature_writing_desc: "Kontextuelle Vorschläge zur Unterstützung des Auszubildenden bei seinen Aktivitäten.",
      feature_activity_skills: "Aktivität/Kompetenzen",
      feature_activity_skills_desc:
        "Identifiziert die eingesetzten RNCP-Kompetenzen und bewertet das erreichte Niveau.",
      profile_rp: "PB",
      profile_admin: "Admin",
      profile_apprentice: "Auszubildende/r",
      profile_tutor: "Betreuer/in",
    },
  },
};
